<!-- 字典列表 -->
<template>
    <div class='page_content'>
        <div class="page_content_top">
            <v-button :buttonList="buttonList" @actionSet="actionSet" :buttonFlag="false"></v-button>
            <div class="page_content_top_line">
                <el-form :inline="true" :model="getRequestData" class="demo-form-inline" label-width="100px">
                    <el-form-item label="编号名称">
                        <label slot="label" :style="$common.labelStyle('编号名称')" v-html="$common.htmlLabel('编号名称')"></label>
                        <el-input class="form_codition" v-model.trim="getRequestData.codeType" size="mini" :clearable="true"
                            placeholder="请输入编号名称"></el-input>
                    </el-form-item>
                    <el-form-item label="编号分类">
                        <label slot="label" :style="$common.labelStyle('编号分类')" v-html="$common.htmlLabel('编号分类')"></label>
                        <el-select class="form_codition" v-model="getRequestData.codeClassify" filterable size="mini"
                            placeholder="编号分类" :clearable="true">
                            <el-option v-for="(item, keys) in cataList" :key="keys" :label="item.dtName"
                                :value="item.codeClassify">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" size="mini" @click="searchData">查询</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </div>
        <div class="page_content_center">
            <el-table size="mini" stripe :data="returnData.list" @selection-change="selecDataAction"
                :height="tableHeight" :key="$store.state.tableNum" border style="width: 100%" highlight-current-row>
                <el-table-column type="selection" width="40">
                </el-table-column>
                <el-table-column align="center" prop="codeClassify" label="编号分类">
                    <template slot-scope="scope">
                        <el-tag size="mini">
                            {{ recodeType(scope.row.codeClassify) }}</el-tag>
                    </template>
                </el-table-column>
                <el-table-column align="center" prop="codeType" label="编号名称">
                </el-table-column>
                <el-table-column align="center" prop="prefix" label="前缀">
                </el-table-column>
                <el-table-column align="center" prop="serialnum" label="数字长度">
                </el-table-column>
            </el-table>
        </div>
        <div class="page_content_bottom">
            <v-pagination :page="getRequestData.page" :rows="getRequestData.rows" :total="returnData.total"
                @setDataPageSize="setDataPageSize" @setDataPageNumber="setDataPageNumber"></v-pagination>

        </div>
        <el-drawer :close-on-press-escape="true" :visible.sync="dialogVisible" :with-header="false"
            append-to-bodycustom-class="drawer_box" direction="ltr" size="50%">
            <codSettingListAction v-if="dialogVisible" ref="codSettingListAction" @drawerCancel="drawerCancel"
                :actionData="actionData"></codSettingListAction>
        </el-drawer>
    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import codSettingListAction from "@/components/codSettingListAction.vue";
export default {
    //import引入的组件需要注入到对象中才能使用
    components: {codSettingListAction},
    data() {
        var _this = this
        //这里存放数据
        return {
            tableHeight: 0,
            cataList: [{
                dtName: '商品',
                codeClassify: 0
            }, {
                dtName: '供应商',
                codeClassify: 1
            }, {
                dtName: '客户',
                codeClassify: 2
            }],
            getRequestData: {
                codeClassify: '',
                // start: new Date(new Date().toLocaleDateString()).getTime() - 31 * 24 * 3600 * 1000,
                // end: new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1,
                ormId: JSON.parse(sessionStorage.getItem("loginInfo")).ormId,
                businessId: '',
                page: 1,
                rows: 30,
            },
            returnData: {
                pages: 0,  // 总页数
                total: 0,  // 总条数
                pageNum: 0,  // 当前页数
                list: []
            },
            buttonList: [],

            dataActionBox: {
                showStatus: false,
                openMode: 'ltr' || 'rtl',
                boxTitle: '新增权限' || '编辑权限',
                actionType: 0, // 0新增，1修改
            },

            selectedDataList: [],

            sendDataInfo: {
                // diName: '',
                diCode: _this.$common.getDateNumber(),
                diValue: '',
                codeClassify: '',
                remark: '',
                diId: '',
            },
            dialogVisible: false,
            rules: {
                diCode: [
                    { required: true, message: '请输入字典编码', trigger: 'submit' },
                ],
                diName: [
                    { required: true, message: '请输入字典名称', trigger: 'submit' }
                ],
                diValue: [
                    { required: true, message: '请输入字典值', trigger: 'submit' }
                ],
                dtId: [
                    { type: 'date', required: true, message: '请选择字典类别', trigger: 'submit' }
                ],
            },



        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {},
    //方法集合
    methods: {
        recodeType(e) {
            let rName = ''
            this.cataList.forEach((item) => {
                if (e == item.codeClassify) {
                    rName = item.dtName
                }
            })
            return rName
        },
        changeTime(val) {
            if (val) {
                var time = val + 24 * 60 * 60 * 1000 - 1;
                this.getRequestData.end = time;
            }
        },
        selecDataAction(data) {
            this.selectedDataList = data
        },
        drawerCancel() {
            this.dialogVisible = false
            this.getDataList()
            this.initActionBox()
        },


        initActionBox() {
            this.sendDataInfo.diCode = this.$common.createCode()
            this.sendDataInfo.diName = ''
            this.sendDataInfo.diValue = ''
            this.sendDataInfo.dtId = ''
            this.sendDataInfo.remark = ''
            this.sendDataInfo.diId = ''

            this.dataActionBox.actionType = 0
            this.dataActionBox.showStatus = false
        },
        openActionBox(cate) {
            this.initActionBox()
            if (cate == 0) {
                this.dataActionBox.boxTitle = '新增编号规则'
                this.dataActionBox.openMode = 'ltr'
            } else {
                this.dataActionBox.boxTitle = '编辑编号规则'
                this.dataActionBox.openMode = 'ltr'
                if (this.getDataDateils() == false) {
                    return false
                }
            }
            this.dataActionBox.actionType = cate
            this.dataActionBox.showStatus = true
        },
        // 获取数据详情
        getDataDateils() {
            if (this.selectedDataList.length < 1) {
                this.$message({
                    message: '请先选择您要修改的数据条目',
                    type: 'error'
                });
                return false
            }

            if (this.selectedDataList.length > 1) {
                this.$message({
                    message: '编辑信息只能选择一条数据，请勿多选',
                    type: 'error'
                });
                return false
            }


            var dataInfo = this.selectedDataList[0]
            this.sendDataInfo.diId = dataInfo.diId
            this.sendDataInfo.diName = dataInfo.diName
            this.sendDataInfo.diCode = dataInfo.diCode
            this.sendDataInfo.diValue = dataInfo.diValue
            this.sendDataInfo.dtId = dataInfo.dtId
            this.sendDataInfo.remark = dataInfo.remark
            return true
        },
        // 动作集合
        actionSet(actionData) {
            console.log(actionData)
            switch (actionData.actionType) {
                case 0:
                    this.dialogVisible = true;
                    this.actionData = {
                        cate: 0,
                        formData: "0",
                        oldData: "",
                        orderId: "",
                        printSouce: "",
                        printJurId: "",
                    };
                    break;
                case 1:
                    if (this.selectedDataList.length < 1) {
                        this.$message({
                            message: '请先选择您要修改的数据条目',
                            type: 'error'
                        });
                        return false
                    }

                    if (this.selectedDataList.length > 1) {
                        this.$message({
                            message: '编辑信息只能选择一条数据，请勿多选',
                            type: 'error'
                        });
                        return false
                    }

                    this.dialogVisible = true;
                    this.actionData = {
                        cate: 1,
                        formData: "0",
                        oldData: this.selectedDataList,
                        orderId: "",
                        printSouce: "",
                        printJurId: "",
                    };
                    this.openActionBox(actionData.actionType)
                    break;
                case 2:
                    this.delDataAction()
                    break;
            }
        },
        async getButtonList() {
            this.buttonList = await this.$common.getActionButton()
        },
        // 数据搜索
        searchData() {
            this.getRequestData.page = 1
            this.getDataList()
        },
        // 修改信息
        toEditPage(dataInfo) {
            sessionStorage.setItem('setDiticariesInfo', JSON.stringify(dataInfo))
            this.$common.pageJump('/editDataDictionaries')
        },

        // 删除
        delDataAction() {
            if (this.selectedDataList.length < 1) {
                this.$message({
                    message: '请先选择您要操作的数据',
                    type: 'error'
                });
                return false
            }
            let dataInfo = []
            this.selectedDataList.forEach(item => {
                dataInfo.push(item.codeId)
            })
            this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                var delData = {
                    ids: dataInfo
                }
                let responseData = await this.$http.deleteQueryCodeSetting(delData)
                if (responseData.status == 200) {
                    this.$message({
                        type: 'success',
                        message: '删除成功!'
                    });
                    this.getDataList()
                } else {
                    this.$message({
                        message: responseData.message,
                        type: 'error'
                    });
                }

            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });
            }).catch(() => { });

        },

        // 获取字典类别
        async getDictionariesCate() {
            let responseData = await this.$http.getDictionariesCate()
            if (responseData.status == 200) {
                this.cataList = responseData.result
            } else {
                this.$message({
                    message: responseData.message,
                    type: 'error'
                });
            }
        },
        // 数据翻页
        setDataPageNumber(val) {
            this.getRequestData.page = val
            this.getDataList()
        },

        // 切换显示条数
        setDataPageSize(val) {
            this.getRequestData.page = 1
            this.getRequestData.rows = val
            this.getDataList()
        },


        // 获取数据列表
        async getDataList() {
            let responseData = await this.$http.getAllQueryCodeSetting(this.getRequestData)
            if (responseData.status == 200) {
                this.returnData.list = responseData.result.list
                this.returnData.pages = responseData.result.pages
                this.returnData.total = responseData.result.total
                this.returnData.pageNum = responseData.result.pageNum
            } else {
                this.$message({
                    message: responseData.message,
                    type: 'error'
                });
            }
        },

    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
        this.getDataList()
        // this.getDictionariesCate()
        this.getButtonList()
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {

    },
    beforeCreate() { }, //生命周期 - 创建之前
    beforeMount() { }, //生命周期 - 挂载之前
    beforeUpdate() { }, //生命周期 - 更新之前
    updated() { this.tableHeight = this.$common.getTableHeight() }, //生命周期 - 更新之后
    beforeDestroy() { }, //生命周期 - 销毁之前
    destroyed() { }, //生命周期 - 销毁完成
    activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style  scoped></style>
